// extracted by mini-css-extract-plugin
export default {"bottomBanner":"BottomBanner_bottomBanner__RxlGk","content":"BottomBanner_content__w+USX"};